import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'app-brandsafety-risk',
  templateUrl: './app-brandsafety-risk.html',
  styleUrls: [
    './app-brandsafety-risk.scss',
    '../../details-page/details-item.css',
    '../../details-page/label-styles.css'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppBrandSafetyRisk implements OnInit {
  @Input() domain;
  @Input() region;
  @Input() os;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();

  currentOpenImageUrl: string;

  deviceTypes = [
    {
      name: 'smartphone',
      tooltip:
        'Combined advertiser risk for the App on Smartphones by business region'
    },
    {
      name: 'tablet',
      tooltip:
        'Combined advertiser risk for the App on Tablets by business region'
    }
  ];

  constructor() {}

  ngOnInit() {}

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }

  toggleAccordion(item: any) {
    if (this.currentOpenImageUrl !== item.url) {
      this.currentOpenImageUrl = item.url;
    } else {
      this.currentOpenImageUrl = null;
    }
  }
}
